import IntlService from 'ember-intl/services/intl';

import { inject as service } from '@ember/service';
import Component from '@glimmer/component';

interface IArgs {
  statType?: string;
  statEmptyText?: string;
  chartYAxisFormat?: string;
  totalLabel?: string;
  currentLabel?: string;
  toDateLabel?: string;
  toPreviousLabel?: string;
  timePeriod?: string;
  showDetails?: boolean;
}
export default class DashboardKpi extends Component<IArgs> {
  @service intl!: IntlService;

  get statType() {
    return this.args.statType ?? 'currency';
  }

  get statEmptyText() {
    return this.args.statEmptyText ?? '-';
  }

  get chartYAxisFormat() {
    return this.args.chartYAxisFormat ?? 'shortScale';
  }

  get totalLabel() {
    return this.args.totalLabel ?? this.intl.t('totalAvg');
  }

  get currentLabel() {
    return this.args.currentLabel ?? this.intl.t('current');
  }

  get toDateLabel() {
    return this.args.toDateLabel ?? this.intl.t('dashboardPage.kpi.evolVsAvg');
  }

  get toPreviousLabel() {
    return (
      this.args.toPreviousLabel ??
      this.intl.t('dashboardPage.kpi.evolVsPrevious', {
        period: (this.args.timePeriod ?? 'N').substring(0, 1)
      })
    );
  }
}
